import { Drawer } from '@mui/material';
import { SearchContent, SearchContentProps } from './search-content.component';
import { useSearchDrawerStyles } from './search-drawer.styles';

export interface SearchDrawerProps extends Omit<SearchContentProps, 'onClose'> {
  isOpen: boolean;
  onToggle: (open: boolean) => void;
}

export function SearchDrawer({ isOpen, onToggle, ...content }: SearchDrawerProps) {
  const classes = useSearchDrawerStyles();
  return (
    <Drawer
      disableEnforceFocus
      classes={{ root: classes.drawer, paper: classes.drawerPaper }}
      // The fixed header sits at z-index ~1301; the Drawer's modal root defaults to 1300, which
      // clips it. An inline style on the modal root beats the class-based default outright (no
      // JSS-order gamble) and is scoped to this drawer only — unlike a global .MuiDrawer-root rule.
      ModalProps={{ style: { zIndex: 2000 } }}
      anchor="right"
      open={isOpen}
      onClose={() => onToggle(false)}
    >
      <SearchContent {...content} onClose={() => onToggle(false)} />
    </Drawer>
  );
}
